<template>
  <ok-modal
    :value="value"
    size="lg"
    dialog-class="tables-modal"
    title="تعديل المعلومات"
    @change="$emit('input',false)"
  >
    <validation-observer ref="form">
      <error-alert
        v-if="error"
        :error="error"
      />
      <b-row>
        <b-col
          md="6"
          sm="12"
        >
          <ok-text-input
            v-model="form.slug"
            :label="$t('fields.slug')"
          />
        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <ok-text-input
            v-model="form.password"
            :label="$t('fields.password')"
          />
        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <ok-phone-number-input
            v-model="form.phone"
            :label="$t('fields.phone-number')"
          />
        </b-col>
        <b-col
          md="6"
          sm="12"
        >
          <ok-text-input
            v-model="form.chat_id"
            label="Chat ID"
          />
        </b-col>
      </b-row>
    </validation-observer>
    <template #actions>
      <div class="d-flex justify-content-end align-items-center">
        <b-button
          variant="outline-dark"
          :disabled="loading"
          @click="submit"
        >
          <b-spinner
            v-if="loading"
            small
            class="ml-1"
          />
          {{ $t('forms.save') }}
        </b-button>
        <b-button
          variant="dark"
          class="ml-1"
          @click="$emit('input',false)"
        >
          {{ $t('forms.cancel') }}
        </b-button>
      </div>
    </template>
  </ok-modal>
</template>

<script>
import {
  BButton, BRow, BCol,
} from 'bootstrap-vue'
import OkModal from '@/@bya3/components/modals/OkModal'
import OkTextInput from '@/@bya3/components/inputs/OkTextInput'
import ErrorAlert from '@/@bya3/components/alerts/ErrorAlert'
import { ValidationObserver } from 'vee-validate'
import AdminUsersApi from '@/api/admin/users'
import OkPhoneNumberInput from '@/@bya3/components/inputs/OkPhoneNumberInput'

export default {
  name: 'UpdateUserModal',
  components: {
    OkPhoneNumberInput,
    ErrorAlert,
    OkTextInput,
    ValidationObserver,
    OkModal,
    BButton,
    BRow,
    BCol,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      error: null,
      form: {
        chat_id: '',
      },
      loading: false,
    }
  },
  watch: {
    user() {
      this.error = null
      this.setForm()
    },
  },
  mounted() {
    this.setForm()
  },
  methods: {
    async setForm() {
      this.form = { ...this.user }
    },
    async submit() {
      this.error = null
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.error = this.$tc('errors.field-invalid', 2)
        this.notifyError = this.$tc('errors.field-invalid', 2)
      } else {
        this.loading = true
        const form = { slug: this.form.slug, phone: this.form.phone, chat_id: this.form?.chat_id }
        if ((this.form?.password ?? '') !== '') form.password = this.form.password
        await AdminUsersApi.updateUser(this.user.id, form).then(async res => {
          if (res.error === 0) {
            this.$emit('updated')
            this.$emit('input', false)
            let str = `اسم المستخدم: ${this.form.slug}`
            str += '\n'
            str += `كلمة المرور: ${this.form.password}`
            await navigator.clipboard.writeText(str)
            this.$notifySuccess(this.$t('general.copy-success'))
          }
        }).catch(e => { this.error = e })
          .finally(() => { this.loading = false })
      }
    },
  },
}
</script>
